(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.buyout-x.controller
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.controller :as pe-controller]
  ))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:fund-name      (:fund-name report-data)
   :reference-date (get-in report-data [:reference-date])
   :tearsheet      (pe-controller/tearsheet-ui-data
                    (update props :dynamic-path concat [:tearsheet]))
   :overview       (pe-controller/overview-ui-data (update props :dynamic-path concat [:overview]))
   :details-and-figures (pe-controller/details-and-figures-ui-data
                         (update props :dynamic-path concat [:details-and-figures]))
   :esg            (pe-controller/esg-ui-data (update props :dynamic-path concat [:esg]))
   :investors      (pe-controller/investors-ui-data
                    (update props :dynamic-path concat [:investors]))})
